import React from "react";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { HiOutlineFlag } from "react-icons/hi";

import { Button } from "../../../../../../../../Components/Button";

export default function ReportDropDown({
  mx,
  my,
  optionsProps,
  classification = "options",
}) {
  let setModalOpen = optionsProps?.setModalOpen;

  let commonProps = {
    classification: classification,
    size: "social",
  };
  return (
    <>
      <DropdownContainer mx={mx || 0} my={my || 0}>
        <Flex flexDirection="column" alignItems="flex-start">
          <Button
            {...commonProps}
            onClick={() => {
              setModalOpen(true); // if this is undefined would case a white screen...
            }}
          >
            <StyledWarning size={18} />
            <ButtonText>Report Profile</ButtonText>
          </Button>
        </Flex>
      </DropdownContainer>
    </>
  );
}

const ButtonText = styled.span`
  margin-left: 8px;
`;

const StyledWarning = styled(HiOutlineFlag)`
  position: relative;
  top: 4px;
`;

const DropdownContainer = styled(Flex)`
  &:hover {
    cursor: default;
  }
`;
